import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { verifyEmail } from '../../../api';
import { useAlerts } from '../../../alerts';

const ValidateEmail = () => {
  const { token } = useParams();
  const { setError, setSuccess, clearErrors } = useAlerts();
  const navigate = useNavigate();

  useEffect(() => {
    return () => clearErrors();
  }, []);

  useEffect(() => {
    verifyEmail(token).then(() => {
      setSuccess('Email verified successfully');
      navigate('/auth/login');
    }).catch(error => {
      setError(error ?? 'Invalid verification code');
    });
  }, [token]);

  return (
    <div></div>
  );
}
export default ValidateEmail;